(ns quuppa.qsm.boot-command.events
  (:require [re-frame.core :as rf]
            [quuppa.utils :as u]
            [quuppa.peweb.query :as q]))

(def boot-commands-query (q/create-query :qpe-boot/get-pending-commands [:qpe-identity]))

(rf/reg-event-fx
  :qpe-boot/register-command
  (fn [_ [_ {:keys [qpe-name command-name] :as params}]]
    {:fx [[:server-dispatch {:event [:qpe-boot/register-command (select-keys params [:qpe-identity :command])]
                             :on-success [:notifications/notify (cond-> {:heading (u/str-format "Command '%s' issued for QPE '%s'"
                                                                                                command-name
                                                                                                qpe-name)
                                                                         :message (u/str-format "'%s' will be executed within one minute for '%s'"
                                                                                                command-name
                                                                                                qpe-name)}
                                                                        (= command-name "restart") (assoc :timeout-ms 30000))]
                             :on-error [:notifications/notify {:type :error
                                                               :heading (u/str-format "Failed to issue '%s' for QPE '%s'"
                                                                                      command-name
                                                                                      qpe-name)
                                                               :message (u/str-format "The command '%s' will not be executed on QPE '%s' since issuing the command failed"
                                                                                      command-name
                                                                                      qpe-name)}]}]]}))

(rf/reg-event-fx
  :qpe-boot/revoke-command
  (fn [_ [_ {:keys [qpe-name command-name] :as params}]]
    {:fx [[:server-dispatch {:event [:qpe-boot/revoke-command (select-keys params
                                                                           ;; Note that `id` would be enough to identify command to revoke,
                                                                           ;; but we send qpe_identity as well
                                                                           ;; so that the backend can broadcast state change
                                                                           ;; to this specific QPE
                                                                           [:qpe-identity :id])]
                             :on-success [:notifications/notify {:heading (u/str-format "Command '%s' revoked from QPE '%s'"
                                                                                        command-name
                                                                                        qpe-name)
                                                                 :message (u/str-format "Command '%s' will not be executed on QPE '%s'"
                                                                                        command-name
                                                                                        qpe-name)}]
                             :on-error [:notifications/notify {:type :error
                                                               :heading (u/str-format "Failed to revoke command '%s' from QPE '%s'"
                                                                                      command-name
                                                                                      qpe-name)
                                                               :message (u/str-format "Command '%s' remains present until executed on QPE '%s'"
                                                                                      command-name
                                                                                      qpe-name)}]}]]}))

(rf/reg-event-db
  :qpe-boot/command-registered
  (q/update-event-fn boot-commands-query
                     (fn [query-db command]
                       (conj query-db command))))

(rf/reg-event-db
  :qpe-boot/command-removed
  (q/update-event-fn boot-commands-query
                     (fn [query-db {:keys [id]}]
                       (into []
                             (remove (fn [command]
                                       (= id (:id command))))
                             query-db))))
